import React from 'react';

function FeatureCard({ icon, title, desc }) {
  return (
    <div className="transform hover:scale-105 transition duration-300 bg-white shadow rounded-md p-6">
      <div className="text-5xl text-yellow-500 mb-4">{icon}</div>
      <h3 className="text-xl font-bold mb-2">{title}</h3>
      <p className="text-gray-600">{desc}</p>
    </div>
  );
}

export default FeatureCard;